import React from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import {
  Div,
  SubPageStatsWrapper,
  SubPageStatName,
  SubPageStat,
  Label,
} from 'legacyComponents/styled/lib';
import { modalStore } from 'apps/modals/app';
import { Participants } from 'legacyComponents/layout/participants';

import { AddLabelsForm } from 'apps/issueTracker/views/addLabelsForm';
import { AddAssigneesForm } from 'apps/issueTracker/views/addAssigneesForm';

import { withNamespaces, Trans } from 'react-i18next';

import { Button } from 'components';
import { Tags } from 'apps/tag';

@withNamespaces()
@inject('issueTrackerManager')
@observer
export class IssuePageStats extends React.Component {
  addLabels = () => {
    const { issueTrackerManager } = this.props;
    const { issuePage: issue } = issueTrackerManager;
    if (issue) {
      issue.addLabels();
    }
    modalStore.SetModalComponent(AddLabelsForm, { issueTrackerManager });
  };

  addAssignees = () => {
    const { issueTrackerManager } = this.props;
    const { issuePage: issue } = issueTrackerManager;
    if (issue) {
      issue.addAssignees();
    }
    modalStore.SetModalComponent(AddAssigneesForm, { issueTrackerManager });
  };

  render() {
    const { issueTrackerManager } = this.props;
    const { issuePage: issue } = issueTrackerManager;

    let labelSection = (
      <SubPageStat data-testid='projectPage-task-labels'>
        No labels yet
      </SubPageStat>
    );
    if (issue?.labels.upstream.length > 0) {
      const labelList = issue?.labels.upstream.map(label => (
        <ListLabel key={label.id} backgroundColor={`#${label.color}`}>
          {label.name}
        </ListLabel>
      ));
      labelSection = (
        <Div data-testid='projectPage-task-labels' margin='0px 0px 10px 20px'>
          {labelList}
        </Div>
      );
    }

    let assigneeSection = (
      <SubPageStat>
        <Trans>No assignees yet</Trans>
      </SubPageStat>
    );
    if (issue?.assignees.length > 0) {
      assigneeSection = (
        <Div margin='0px 0px 10px 20px'>
          <Participants participants={issue?.assignees.upstream} />
        </Div>
      );
    }

    let participantSection = (
      <SubPageStat>
        <Trans>No participants yet</Trans>
      </SubPageStat>
    );
    if (issue?.commenters.apps.length > 0) {
      participantSection = (
        <Div margin='0px 0px 10px 20px'>
          <Participants participants={issue?.commenters} />
        </Div>
      );
    }

    let skillsSection = (
      <SubPageStat data-testid='projectPage-task-skills'>
        <Trans>No added skills</Trans>
      </SubPageStat>
    );

    if (issue?.tags.length > 0) {
      skillsSection = (
        <Div data-testid='projectPage-task-skills' margin='0px 0px 10px 20px'>
          <Tags tags={issue?.tags} app={issue} />
        </Div>
      );
    }

    return (
      <SubPageStatsWrapper>
        {issue?.canUpdate && (
          <IssueActions>
            {issue?.status === 'Open' ? (
              <Button
                data-testid='projectPage-closeTask-button'
                text={<Trans>Close issue</Trans>}
                onClick={issueTrackerManager.CloseIssue}
                size='small'
                icon='check'
                outline
                variant='primary'
              />
            ) : (
              <Button
                data-testid='projectPage-reopenTask-button'
                text={<Trans>Reopen issue</Trans>}
                onClick={issueTrackerManager.ReOpenIssue}
                size='small'
                outline
              />
            )}
          </IssueActions>
        )}
        <Div position='relative'>
          <SubPageStatName first>
            <Trans>Labels</Trans>
          </SubPageStatName>
          {issue?.canAddDeleteLabels && (
            <ButtonAddStyled
              variant='secondary'
              size='xsmall'
              icon='add'
              onClick={this.addLabels}
              outline
            />
          )}
        </Div>
        {labelSection}
        <Div position='relative'>
          <SubPageStatName>
            <Trans>Assignees</Trans>
          </SubPageStatName>
          {issue?.inSpace.whichTypes.includes('TrackerIssueAssignee') && (
            <ButtonAddStyled
              variant='secondary'
              size='xsmall'
              icon='add'
              onClick={this.addAssignees}
              outline
            />
          )}
        </Div>
        {assigneeSection}
        <Div position='relative'>
          <SubPageStatName>
            <Trans>Participants</Trans>
          </SubPageStatName>
        </Div>
        {participantSection}
        <Div position='relative'>
          <SubPageStatName>
            <Trans>Skills</Trans>
          </SubPageStatName>
        </Div>
        {skillsSection}
      </SubPageStatsWrapper>
    );
  }
}

const ButtonAddStyled = styled(Button)`
  position: absolute;
  top: -3px;
  right: 0;
`;

const ListLabel = styled(Label)`
  display: table;
  margin-bottom: 15px;
`;

const IssueActions = styled.div`
  /* FIXME: Replace space values by theme space values */
  padding-bottom: 10px;
  margin-bottom: 20px;
  text-align: right;
`;

IssuePageStats.propTypes = {
  issueTrackerManager: PropTypes.object,
};
